var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAltaTecnologiaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 0H3.125C1.83105 0 0.78125 1.0498 0.78125 2.34375V22.6562C0.78125 23.9502 1.83105 25 3.125 25H20.3125C21.6064 25 22.6562 23.9502 22.6562 22.6562V2.34375C22.6562 1.0498 21.6064 0 20.3125 0ZM11.7188 23.4375C10.8545 23.4375 10.1562 22.7393 10.1562 21.875C10.1562 21.0107 10.8545 20.3125 11.7188 20.3125C12.583 20.3125 13.2812 21.0107 13.2812 21.875C13.2812 22.7393 12.583 23.4375 11.7188 23.4375ZM20.3125 18.1641C20.3125 18.4863 20.0488 18.75 19.7266 18.75H3.71094C3.38867 18.75 3.125 18.4863 3.125 18.1641V2.92969C3.125 2.60742 3.38867 2.34375 3.71094 2.34375H19.7266C20.0488 2.34375 20.3125 2.60742 20.3125 2.92969V18.1641Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltaTecnologiaIcon);
export default __webpack_public_path__ + "static/media/alta_tecnologia_icon.f1d8303af6911ae75212f982991fae6f.svg";
export { ForwardRef as ReactComponent };